module.exports = __webpack_public_path__ + "static/media/downArrow.b6362580.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downArrow.svg
// module id = 698
// module chunks = 0